import { FC } from "react";

export const Label: FC = (props: any) => {
  return (
    <text x={props.x - 7} y={props.y - 7} fill="grey" textAnchor="start">
      {props.value}
    </text>
  );
};
